﻿import { defineComponent, ref } from "/Scripts/vue.esm-browser.js";

const html = String.raw;

export default defineComponent({
    name: "StoresBBC",

    props: {
        webSite: {
            type: String,
            required: true,
        },
        bbcSn: {
            type: Number,
            required: false,
        },
    },
    components: {},
    setup(props, { emit }) {
        const data = ref({});
        if (props.webSite === "bbc" && props.bbcSn) {
            window.AjaxPostLite(
                "getBBCHeaderInfo",
                { SN: props.bbcSn },
                function (res) {
                    if (res.MSG == null) {
                        data.value = res.DATA.enties.TBLBBC_ACCOUNT[0];
                    }
                }
            );
        }
        const openMaps = (OpenAdds, OpenName) => {
            const openURL = 'https://www.google.com.tw/maps/place/' + OpenAdds + '/?hl=zh-TW';
            window.open(openURL, '_blank');
        }
        return { data, openMaps };
    },
    template: html`
        <div class="stores">
            <div class="ctbox">
                {{data.A_nm}}
                <br />
                地址：{{getAddr(data)}}
                <a
                    @click="openMaps(getAddr(data),data.A_nm)"
                    class="sbtn"
                    target="_parent"
                >
                    地圖
                </a>
                <br />
            </div>
            <div class="ctbox">
                {{data.A_id}}
                <br />
                電話：{{data.A_tel0+'-'+data.A_tel1}}&nbsp;&nbsp;傳真：{{data.A_fax}}
            </div>
            <div class="ctbox">
                客服人員：{{data.C_name}}
                <br />

                客服信箱：
                <a
                    id="bbcmail"
                    :href="'mailto:'+data.C_email"
                    class="link"
                    target="_parent"
                >
                    {{data.C_email}}
                </a>
            </div>
        </div>
    `,
    methods: {
        getAddr: function (data) {
            let addr = "";
            if (data.A_addr0 && data.A_addr1) {
                addr = data.A_addr0 + "-" + data.A_addr1;
            }
            else if (data.A_addr1) {
                addr = data.A_addr1;
            }
            return addr
        }
    },
});
